import { useState } from 'react';

import { useConnectedWallet } from '~/contextProviders/ConnectedWallerProvider';
import { useSubmitNewsletter } from '~/hooks/newsletter/useSubmitNewsletter';
import { useSubmitEmailVerified } from '~/hooks/tournament/useSubmitEmailVerified';

function FormSuccess() {
  return (
    <div className="mb-space-xs">
      <div>Please check your email for a verification link to continue.</div>
    </div>
  );
}

export function SignUpForm({ setIsSuccess }: { setIsSuccess: any }) {
  const [email, setEmail] = useState('');
  const [age, setAge] = useState(false);
  const [terms, setTerms] = useState(false);
  const { account } = useConnectedWallet();
  const {
    mutate: setSubmitTournamentSignUp,
    isLoading,
    isSuccess,
    isError,
  } = useSubmitEmailVerified();
  const { mutate: setSubmitNewsletter } = useSubmitNewsletter();
  const handleSubmit = (event: React.SyntheticEvent): void => {
    event.preventDefault();
    if (account?.address) {
      setSubmitTournamentSignUp(
        {
          email: email,
          address: account.address,
        },
        {
          onSuccess: () => {
            setIsSuccess(true);
            setSubmitNewsletter({
              email: email,
            });
          },
          onError: (err: any) => {
            console.log('err', err);
          },
        }
      );
    }
  };

  if (isSuccess) {
    return <FormSuccess />;
  }

  return (
    <>
      {isError && (
        <div className="mb-space-xs text--error">
          <div>Verification did work, please try again.</div>
        </div>
      )}
      <form className="form--signup" action="" onSubmit={handleSubmit}>
        <div className="mb-space-xs">
          <label htmlFor="email">
            Email Address (will need to verify your email)
          </label>
          <input
            className="mb-space-xs mt-space-xs"
            type="email"
            name="email"
            value={email}
            required={true}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="mb-space-xs">
          <input
            type="checkbox"
            id="age"
            name="age"
            required
            checked={age}
            onChange={() => setAge(!age)}
          />
          <label htmlFor="age">I am over 18 years of age.</label>
        </div>

        <div className="mb-space-xs">
          <input
            type="checkbox"
            id="terms"
            name="terms"
            required
            checked={terms}
            onChange={() => setTerms(!terms)}
          />
          <label htmlFor="terms">
            I agree to the{' '}
            {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
            <a href="/terms/tournament" target={'_blank'} className="link">
              official rules
            </a>
            .
          </label>
        </div>

        <div className="button-row">
          <button
            className="button"
            type="submit"
            disabled={isLoading || !(email && age && terms) ? true : false}
          >
            {isLoading ? 'Submit...' : 'Submit'}
          </button>
        </div>
      </form>
    </>
  );
}

export function PromptToSignUp({ setShowForm }: { setShowForm: any }) {
  return (
    <>
      <h3 className="signup--header">You have eligible Warriors!</h3>
      <div>(You can always get more later)</div>
      <div className="revival__load-more">
        <button
          className="revival-button button"
          type="button"
          onClick={() => setShowForm(true)}
        >
          Sign Up Now!
        </button>
      </div>
    </>
  );
}
